module.exports = __webpack_public_path__ + "static/media/Supe_256x256px.6c7be25d.jpg";